import { agencyActionTypes } from "./currentAgencyActionTypes";

export const storeAgencyDetails = (data) => ({
  type: agencyActionTypes.STORE_AGENCY_DETAILS,
  payload: data,
});
